var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParentOrganizations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2H2V21H14V19V7V5V2ZM2 0C0.89543 0 0 0.89543 0 2V21C0 22.1046 0.89543 23 2 23H14C15.1046 23 16 22.1046 16 21V2C16 0.895431 15.1046 0 14 0L2 0Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 3,
    height: 3,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 3,
    height: 3,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 3,
    height: 3,
    rx: 1,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 3,
    height: 3,
    rx: 1,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 3,
    height: 3,
    rx: 1,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 3,
    height: 3,
    rx: 1,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 19,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentOrganizations);
export default __webpack_public_path__ + "static/media/ParentOrganizations.de1eb1e5212d892d3edf089615664a38.svg";
export { ForwardRef as ReactComponent };